<template>
<div id="adminFooter">
  <div class="footer">
    copyright NICE D&amp;B inc All Rights reserved. 통신판매업신고: 제2012-서울마포-0168호
  </div> 
</div> 
</template>